import { flow, fn } from '@code-expert/prelude';
import { useStaleWhileRevalidate as useCached } from '@code-expert/react';
import { makeUseProcedure } from './makeUseProcedure.js';
/**
 * Call a procedure and represent the states before, during and after as Remote.
 * - Immediately return `Pending` on the very first render.
 * - Return `Done` when the procedure call returns.
 * - Call the procedure again whenever `props` changes but keep returning the most
 *   recent result according to Stale-While-Revalidate.
 * - Never return `Initial`.
 */
export const makeUseCachedProcedure = (socket, options) => flow(makeUseProcedure(socket, options), ([result, refresh, refreshO]) => fn.tuple(useCached(result), refresh, refreshO));
//# sourceMappingURL=makeUseCachedProcedure.js.map